module.exports = __webpack_public_path__ + "img/browser_uo-2.1da975c1.png";